import { JiraIssueFieldOptionAri } from '@atlassian/ari/jira/issue-field-option';
var CLOUD_ID_MOCK = 'cloud-id';
var ACTIVATION_ID_MOCK = 'activation-id';
var FIELD_ID_MOCK = 'field-1';
export var isAriResourceIdValid = function isAriResourceIdValid(optionId) {
  try {
    JiraIssueFieldOptionAri.create({
      siteId: CLOUD_ID_MOCK,
      activationId: ACTIVATION_ID_MOCK,
      fieldId: FIELD_ID_MOCK,
      optionId: optionId
    });
    return true;
  } catch (e) {
    return false;
  }
};